import { render } from "./ApartmentLoader.vue?vue&type=template&id=129f08d3&scoped=true"
import script from "./ApartmentLoader.vue?vue&type=script&lang=js"
export * from "./ApartmentLoader.vue?vue&type=script&lang=js"

import "./ApartmentLoader.vue?vue&type=style&index=0&id=129f08d3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-129f08d3"

export default script